module.exports = __webpack_public_path__ + "static/media/Tooltip-active.6c34f2b6.svg";